import { Box, HStack, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";
import { TableBoxHeaderExpandButton } from "shared/components/table/box/TableBoxHeaderExpandButton";

export interface TableBoxTitleProps {
  textStyle?: string;
}

export const TableBoxTitle: React.FC<
  React.PropsWithChildren<TableBoxTitleProps>
> = ({ textStyle = "h6Bold", children }) => {
  const { setTitle } = useTableBoxContext();
  const { isCollapsible, isExpanded, toggleExpanded, isFullScreen } =
    useTableBoxContext();
  useEffect(() => {
    if (children) {
      setTitle(children as string);
    }
  }, [children, setTitle]);

  const title = (
    <Text
      as={Box}
      textStyle={textStyle}
      textColor="gray.700"
      data-ls-enabled={true}
      data-public={true}
    >
      {children}
    </Text>
  );

  return (
    <HStack alignItems="center">
      {isCollapsible && !isFullScreen ? (
        <TableBoxHeaderExpandButton
          isExpanded={isExpanded}
          onClick={toggleExpanded}
          paddingLeft="20px"
        >
          {title}
        </TableBoxHeaderExpandButton>
      ) : (
        title
      )}
    </HStack>
  );
};
